module.exports = __webpack_public_path__ + "img/PC_01.8e10be2e.jpg";